module.exports = __webpack_public_path__ + "svg/prospeneo-logo-dark.f2777ae8.svg";